import { History } from '../server/history';

export class HistorySectionRefreshEvent {
    public constructor(
        public folderId: string,
        public histories: History[]
    ) {}
}
